"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuoteText = exports.Content = exports.Container = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setFontWeight = weight => {
  switch (weight) {
    case 'normal':
      return (0, _styledComponents.css)`
      ${(0, _typography.setFontSizes)({
        xs: '32px',
        lg: '48px'
      })}
      font-family: 'univers-roman';
      line-height: 120%;
      `;
    case 'bold':
      return (0, _styledComponents.css)`
      ${(0, _typography.setFontSizes)({
        xs: '24px',
        lg: '48px'
      })}
      ${(0, _typography.setFont)({
        bold: true
      })}
      line-height: 110%;
      letter-spacing: -0.03em;
      `;
    case 'deville':
      return (0, _styledComponents.css)`
      ${(0, _typography.setFontSizes)({
        xs: '32px',
        lg: '48px'
      })}
      ${(0, _typography.setFont)({
        display: true
      })}
      line-height: 120%;
      `;
    default:
      return (0, _styledComponents.css)`
      ${(0, _typography.setFontSizes)({
        xs: '32px',
        lg: '48px'
      })}
      ${(0, _typography.setFont)({
        display: true
      })}
      line-height: 120%;
      `;
  }
};
const Container = _styledComponents.default.div`
  ${props => (0, _layout.setContainer)({
  size: props.lineWidth === 'wide' ? 'xl' : 'sm'
})}
`;
exports.Container = Container;
const QuoteText = _styledComponents.default.h4`
  margin: 0 auto;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: ${props => props.fontColor || 'inherit'};
  ${props => setFontWeight(props.fontWeight)};
`;
exports.QuoteText = QuoteText;
const Content = _styledComponents.default.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 0;
  blockquote {
    margin: 0px;
  }
`;
exports.Content = Content;
//# sourceMappingURL=styles.js.map